import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { DataLoaderService } from '../services/data-loader.service';

@Injectable()
export class DataLoaderInterceptor implements HttpInterceptor {
  constructor(private dataLoader: DataLoaderService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    this.dataLoader.showLoader();
    return next.handle(request).pipe(
      finalize(() => {
        this.dataLoader.hideLoader();
      })
    );
  }
}
